import { render } from "./LanguageBar.vue?vue&type=template&id=780fe978&scoped=true"
import script from "./LanguageBar.vue?vue&type=script&lang=js"
export * from "./LanguageBar.vue?vue&type=script&lang=js"

import "./LanguageBar.vue?vue&type=style&index=0&id=780fe978&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780fe978"]])

export default __exports__